module.exports = __webpack_public_path__ + "static/media/-_pay slip.27ea97ef.png";